  <h2 *ngIf="headerString">{{ headerString }}</h2>
  <div *ngIf="isFileUploadLoading" class="loading-overlay">
    <p-progressSpinner></p-progressSpinner>
  </div>
  <div class="container">
    <div class="formgrid grid">
      <div class="p-fluid field" [class.col-12]="isDownloadMode === true" [class.col-4]="isDownloadMode === false">
          <label>{{ 'ReceiptFormUpload.DocumentType' | translate }}</label>
          <p-dropdown appendTo="body" [options]="docTypeOptions" [(ngModel)]="selectedDocType" (onChange)="onDocTypeChange($event)" placeholder="{{ 'Common.DropDown.Select' | translate }}">
          </p-dropdown>
          <div class="formgrid grid mt-4">
            <div class="col">
              <button style="width: 100%;" [disabled]="this.selectedDocType == '' || !this.documents || this.documents.length == 0" pButton type="button" label="{{ 'FileDownload.Button.PDF' | translate }}" (click)="downloadPdf($event)" icon="pi pi-download" iconPos="right" ></button>
            </div>
            <div class="col">
              <button style="width: 100%;" [disabled]="this.selectedDocType == '' || !this.documents || this.documents.length == 0" pButton type="button" label="{{ 'FileDownload.Button.ZIP' | translate }}" (click)="downloadZip($event)" icon="pi pi-download" iconPos="right" ></button>
            </div>
          </div>
      </div>
      <div class="field col-8" *ngIf="!isDownloadMode">
          <label>{{ 'ReceiptFormUpload.File' | translate }}</label>

            <div *ngIf="this.referenceKeys && this.referenceKeys.length == 1 && this.fileCategory.docCategory == '6' " style="float: right;" pTooltip="{{ 'FileUpload.MergeFile.MergeBtn' | translate  }}">
              <label class="mb-2">{{ 'FileUpload.MutlipleFile' | translate }}</label>
              <p-inputSwitch class="ml-2 mt-2" [(ngModel)]="isMergeFile" [disabled]="switchMergeDisable" ></p-inputSwitch>
            </div>

            <div *ngIf="this.referenceKeys && this.referenceKeys.length > 1" style="float: right;">
              <label class="mb-2">{{ 'FileUpload.MutlipleFile' | translate }}</label>
              <p-inputSwitch class="ml-2 mt-2" [(ngModel)]="isMultiple" [disabled]="switchDisable" ></p-inputSwitch>
            </div>

            <p-fileUpload
            [disabled]="this.selectedDocType == ''"
            #fileUpload
            [multiple]="isMultiple || isMergeFile"
            [customUpload]="true"
            (onClear)="onClearFiles($event)"
            (onRemove)="onRemoveFiles($event)"
            (onSelect)="onSelectedFiles($event)"
            (uploadHandler)="fileUploader($event)"
            chooseLabel="{{ 'ReceiptFormUpload.Select' | translate }}"
            uploadLabel="{{ 'ReceiptFormUpload.Upload' | translate }}"
            cancelLabel="{{ 'ReceiptFormUpload.Cancel' | translate }}">

                <ng-template class="p-fileupload-content" let-file let-index pTemplate="file">
                    <div class="p-fileupload-row" >
                      <div>
                        <p-dropdown *ngIf="referenceKeys && referenceKeys.length > 1 && isMultiple" placeholder="Choose" [(ngModel)]="this.uploadFileBeans[fileUpload._files.indexOf(file)].referenceKey" (onChange)="onSelectReferenceKey($event, file)" appendTo="body" [options]="referenceKeys"> </p-dropdown>
                      </div>
                      <div>{{ file.name }}</div>
                      <div>{{ fileUpload.formatSize(file.size) }}</div>
                      <div>
                        <button type="button" icon="pi pi-times" pButton (click)="fileUpload.remove($event, fileUpload._files.indexOf(file))" [disabled]="fileUpload.uploading"></button>
                      </div>
                    </div>
                </ng-template>
          </p-fileUpload>
      </div>

    </div>
  </div>
  <div class="mt-2">
    <p-table class="datatable" [value]="documents" [resizableColumns]="true" [reorderableColumns]="true" [rowHover]="true" [loading]="isLoading" columnResizeMode="expand" [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10, 25, 50]" [autoLayout]="true" sortMode="multiple"
    >
        <ng-template pTemplate="header">
            <tr>
              <th *ngIf="this.fileCategory !=null && ['1', '6', '7'].includes(this.fileCategory.docCategory)" pResizableColumn pReorderableColumn>DoNo</th>
              <th *ngIf="this.fileCategory !=null && ['2'].includes(this.fileCategory.docCategory)" pResizableColumn pReorderableColumn>AD/ASN No</th>
              <th *ngIf="this.fileCategory !=null && ['8'].includes(this.fileCategory.docCategory)" pResizableColumn pReorderableColumn>提單號碼</th>
              <th pResizableColumn pReorderableColumn>{{ 'ReceiptFormUpload.FileType' | translate }}</th>
              <th pResizableColumn pReorderableColumn>{{ 'ReceiptFormUpload.Version' | translate }}</th>
              <th pResizableColumn pReorderableColumn>{{ 'ReceiptFormUpload.UploadBy' | translate }}</th>
              <th pResizableColumn pReorderableColumn>{{ 'ReceiptFormUpload.LastUpdateTime' | translate }}</th>
              <th pResizableColumn pReorderableColumn>{{ 'ReceiptFormUpload.Download' | translate }}</th>
              <th pResizableColumn pReorderableColumn>{{ 'ReceiptFormUpload.Delete' | translate }}</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData>
            <tr>
                <td>{{ rowData.referenceKey }}</td>
                <td>{{ rowData.docType }}</td>
                <td>{{ rowData.version }}</td>
                <td>{{ rowData.updateUser }}</td>
                <td>{{ rowData.updateDt | date:'yyyy/MM/dd HH:mm:ss' }}</td>
                <div *ngIf="rowData.isNeedRefresh then refresh else download"></div>
                <ng-template #download>
                  <td>
                    <i class="pi pi-cloud-download" (click)="downloadChange($event, rowData)"></i>
                  </td>
                </ng-template>
                <ng-template #refresh>
                  <td>
                    <i class="pi pi-refresh" (click)="attachFile($event, rowData)"></i>
                  </td>
                </ng-template>
                <td>
                    <i class="pi pi-trash" *ngIf="canDeleteFile(rowData)" (click)="deleteFileBtnClick($event, rowData)"></i>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td [attr.colspan]="7" style="text-align: left;">
                    {{ 'Common.Table.NoData' | translate }}
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>

